import * as React from 'react';

import { parseResultData } from '~teacher/components/ActivityResult/util/parseResultData';
import { ResultsGrid } from '~teacher/components/ResultsGrid';
import {
  Activity,
  ApiQuestionResponse,
  Room,
  Student,
} from '~teacher/models/activities';
import { Quiz, QuizAnswer, QuizQuestion } from '~teacher/models/quizzes';

import { StudentScore, StudentScoreProvider } from '../StudentScore';
import { useResultState } from './ActivityResultProvider';
import { normalizeQuestions } from './util/normalizeQuestions';
import { normalizeResponses } from './util/normalizeResponses';
import { normalizeStudent } from './util/normalizeStudent';

interface Props {
  activity: Activity;
  students: Record<string, Student>;
  responses: Record<string, ApiQuestionResponse>;
  quiz: Quiz;
  quizQuestion: Record<string, QuizQuestion>;
  quizAnswer: Record<string, QuizAnswer>;
  room: Room;
}

const ActivityResultFinished = (props: Props) => {
  const { questionScores } = useResultState();
  const activity = props.activity;
  const answers = props.quizAnswer;
  const responses = normalizeResponses({
    quizQuestion: props.quizQuestion,
    students: props.students,
    responses: props.responses,
  });
  const questions = normalizeQuestions(props.quizQuestion);
  const students = normalizeStudent(props.students);

  const parsedActivityData = parseResultData({
    activity,
    answers,
    responses,
    questions,
    students,
    questionScores,
  });

  return (
    <StudentScoreProvider>
      <ResultsGrid
        resultsTableQuestions={parsedActivityData.resultsTableQuestions}
        participants={parsedActivityData.participants}
        maxScore={parsedActivityData.maxScore}
        activityInstanceId={parsedActivityData.activityInstanceId}
        activityStage={parsedActivityData.activityStage}
        isRosteredRoom={props.room.isRostered}
        passRate={parsedActivityData.passRate}
        totalStudents={activity.totalStudents}
        presentStudents={activity.presentStudents}
        completionRate={activity.completionRate}
        averageScoreRate={activity.averageScoreRate}
        passingStudentsRate={activity.passingStudentsRate}
      />
      <StudentScore
        activity={activity}
        questions={questions}
        responses={responses}
        students={students}
      />
    </StudentScoreProvider>
  );
};

export { ActivityResultFinished };
